const ArrowAlt = ({ className, styles }) => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 1L5.21788 4.90296C5.09251 5.03235 4.9075 5.03235 4.78212 4.90296L1 1"
        stroke="#0000C9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...styles}
      />
    </svg>
  )
}

export default ArrowAlt
